import React from 'react';
export function SolutionSection() {
  const scrollToPurchase = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-20 px-4 max-w-4xl mx-auto" data-id="element-247">
      <div className="text-center mb-12" data-id="element-248">
        <span className="text-5xl mb-4 block" data-id="element-249">🔥</span>
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-250">
          El sistema que están usando profesores de italiano para escalar
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-251">
        {['Cómo convertir tu conocimiento en un curso irresistible', 'Cómo atraer alumnos todos los días con contenido simple', 'Cómo vender sin perseguir ni convencer', 'Cómo automatizar para generar ingresos constantes'].map((item, i) => <div key={i} className="glass-card p-6 rounded-2xl flex items-start" data-id="element-252">
            <div className="bg-brand-green/20 p-2 rounded-full mr-4 shrink-0 mt-1" data-id="element-253">
              <svg className="w-5 h-5 text-brand-green" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-254">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" data-id="element-255" />
              </svg>
            </div>
            <p className="text-lg text-gray-200 font-medium" data-id="element-256">{item}</p>
          </div>)}
      </div>

      <div className="text-center mb-12" data-id="element-257">
        <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-258">
          No necesitas ser influencer. No necesitas miles de seguidores.{' '}
          <span className="text-brand-gold font-bold" data-id="element-259">
            Necesitas el sistema correcto.
          </span>
        </p>
      </div>

      <div className="text-center" data-id="element-260">
        <button onClick={scrollToPurchase} className="w-full md:w-auto bg-brand-green hover:bg-green-600 text-white font-bold text-xl py-4 px-8 rounded-xl shadow-[0_0_15px_rgba(0,146,70,0.3)] transition-all transform hover:scale-105" data-id="element-261">
          👉 Sí, quiero este sistema
        </button>
      </div>
    </section>;
}